import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconAlignRight = (props?: SvgProps) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M18.2507 8.33333H7.41732M18.2507 5H4.08398M18.2507 11.6667H4.08398M18.2507 15H7.41732"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
